var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"return-button-container"},[_c('button',{staticClass:"return-button-content",on:{"click":_vm.back}})])
}
var staticRenderFns = []

export { render, staticRenderFns }